export enum RequestHeaders {
  Authorization = 'Authorization',
  SkipAuthorization = 'Skip-Authorization',
  UseReportingUrl = 'Use-Reporting-Url',
  Bearer = 'Bearer',
  ContentType = 'Content-Type'
};
